export const de = {
  languageCode: 'de',
  nativeName: 'Deutsch',
  hello: 'Hallo',
  welcome: 'Willkommen',
  enterName: 'Name',
  rooms: 'Räume',
  findPerfectRoom:
    'Finde den perfekten Raum, um deine Sprachkenntnisse zu üben',
  createRoom: 'Raum erstellen',
  filterRooms: 'Räume filtern',
  activeFilters: 'Aktive Filter',
  searchIn: 'Suche in',
  whyItWorks: 'Warum es funktioniert',
  howItWorks: 'Wie es funktioniert',
  targetGroup: 'Zielgruppe',
  earlyAccess: 'Frühzeitiger Zugang',
  speakLearnConnect: 'Sprechen. Lernen. Connecten.',
  whyLanguageRoomsWorks: 'Warum Language Rooms funktioniert',
  theLanguageRoomsMethod: 'Die Language Rooms Methode',
  howLanguageRoomsWorks: 'Wie Language Rooms funktioniert',
  becomeALanguageRoomsPioneer: 'Werde ein Language Rooms Pionier',
  yourVoiceMatters: 'Deine Meinung zählt',
  perfectForIntermediateLearnersAndBeyond:
    'Perfekt für fortgeschrittene Lerner und darüber hinaus',
  whoBenefitsMost: 'Wer profitiert am meisten',
  ourExcitingRoadmap: 'Unsere spannende Roadmap',
  whyYourFeedBackIsCrucial: 'Was können wir verbessern?',
  howToProvideFeedback: 'Wie du Feedback geben kannst',
  speakEarlySpeakOften: 'Sprich früh, sprich oft',
  learnFromNativeSpeakers: 'Lerne von Muttersprachlern',
  embraceTheFun: 'Sprechen macht Spaß',
  progressingLearners: 'Fortschreitende Lernende',
  rustySpeakers: 'Sprachskills auffrischen',
  skillMaintainers: 'Sprachskills beibehalten',
  culturalEnthusiasts: 'Kulturbegeisterte',
  joinARoom: 'Tritt einem Raum bei',
  startSpeaking: 'Fang an zu sprechen',
  levelUpYourLingo: 'Verbessere deine Sprache',
  phaseOneLaunch: 'Phase 1: Start',
  phaseTwoCommunityGrowth: 'Phase 2: Community Wachstum',
  phaseThreeGlobalScale: 'Phase 3: Globale Skalierung',
  traditionalMethod: 'Traditionelle Methode',
  languageRoomsMethod: 'Language Rooms Methode',
  join: 'Beitreten',
  create: 'Erstellen',
  save: 'Speichern',
  cancel: 'Abbrechen',
  leave: 'Verlassen',
  checkAudioDevices: 'Audiogeräte überprüfen',
  mute: 'Stummschalten',
  unmute: 'Stummschaltung aufheben',
  back: 'Zurück',
  joinTheWaitlist: 'Der Warteliste beitreten',
  exploreRooms: 'Räume erkunden',
  requestEarlyAccess: 'Frühzeitigen Zugang anfordern',
  earlyAccessRequested: 'Frühzeitiger Zugang angefordert',
  searchRooms: 'Suche nach Titel oder Beschreibung...',
  allLanguages: 'Alle Sprachen',
  allLevels: 'Alle Levels',
  search: 'Suche',
  title: 'Titel',
  description: 'Beschreibung',
  difficulty: 'Schwierigkeitsgrad',
  tags: 'Tags',
  maxTags: 'maximal {0}',
  charactersMax: 'maximal {0} Zeichen',
  maximal: 'maximal',
  titlePlaceholder: 'Gib einen beschreibenden Titel für deinen Raum ein',
  descriptionPlaceholder:
    'Beschreibe, was die Teilnehmer in deinem Raum erwartet',
  allRightsReservedFunny:
    "Alle Rechte vorbehalten. Jetzt geh und übe deine gerollten R's!",
  connectWithNativeSpeakersEngage:
    'Knüpfe Kontakte zu Muttersprachlern, führe echte Gespräche und lerne durch Sprechen. Tritt unserer großartigen Community bei.',
  ourPlatformFocusesOnSpeaking:
    'Unsere Plattform konzentriert sich aufs Sprechen, damit das Sprachenlernen Spaß macht und effektiv ist.',
  weHaveThreeCorePrinciples:
    'Wir haben drei Kernprinzipien als Grundlage von Language Rooms. Sie sind getestet und bewährt, um schnelles und effektives Lernen zu ermöglichen.',
  languageRoomsIsDesignedTo:
    'Language Rooms ist darauf ausgelegt, deine Fähigkeiten auf die nächste Stufe zu heben. Ob du deine Sprachkenntnisse verbessern, aufrechterhalten oder wiedererlangen möchtest, unsere Plattform bietet die perfekte Umgebung.',
  wereGraduatelyOpeningOurDoors:
    'Willkommen bei Language Rooms! Werde Gründungsmitglied und starte echte Gespräche.',
  welcomeMessage: 'Willkommen bei Language Rooms!',
  founderBadgeTitle: 'Gründungsmitglied',
  welcomeToLanguageRooms: 'Willkommen bei Language Rooms!',
  welcomeSubtitle: 'Der schnellste Weg, Sprachen selbstbewusst zu sprechen',
  welcomeDescription:
    'Du bist einer unserer ersten Besucher! Hilf uns dabei, die effektivste Plattform für Sprechpraxis zu gestalten.',
  joinPioneerCommunity: 'Werde Teil unserer Pionier-Community',
  pioneerCommunityDescription:
    'Sei unter den Ersten, die Sprachen durch echte Gespräche üben',
  earlyAccessBenefits: 'Early Access Vorteile',
  earlyAccessBenefitsDescription:
    'Erhalte exklusive Features und Priority-Support als Gründungsmitglied',
  helpUsGrow: 'Gestalte die Zukunft mit',
  helpUsGrowDescription:
    'Dein Feedback hilft uns, die beste Plattform für Sprechpraxis zu entwickeln',
  whySpeakingMatters: 'Warum Sprechen so wichtig ist',
  whySpeakingMattersDescription:
    'Sprechen ist der schnellste Weg, eine Sprache zu meistern. Schluss mit stillem Lernen - fang jetzt an zu sprechen!',
  getStartedButton: 'Jetzt loslegen',
  weValueYourInput: 'Dein Feedback ist uns wichtig',
  lookForTheFeedbackButton:
    'Suche nach dem "Feedback geben" Button unten rechts auf jeder Seite. Dein Feedback hilft uns, die bestmögliche Sprachlernerfahrung zu schaffen.',
  sevenYears: '7 Jahre',
  threeMonths: '3 Monate',
  yearsOfTextBooksAndGrammar:
    'Jahre des Lernens mit Lehrbüchern und Grammatikübungen führten dazu, Verben perfekt beugen zu können. Allerdings auch zu Panik in echten Gesprächen.',
  immersiveLearningAndRealConversations:
    'Echte Gespräche führten in nur drei Monaten zu selbstbewussten Spanischkenntnissen.',
  noMoreYearsOfSilentStudy:
    'Keine Jahre des stillen Lernens mehr. Fang sofort an zu sprechen, auch wenn es nur "Hola" ist. So habe ich meine Spanischreise begonnen.',
  textBooksCantTeachYou:
    'Lehrbücher können dir nicht beibringen, wie Einheimische wirklich sprechen. Unsere Plattform verbindet dich mit Muttersprachlern für authentischen, praktischen Sprachgebrauch.',
  learningALanguageShouldBeFun:
    'Eine Sprache zu lernen sollte Spaß machen. Wir haben in jeden Aspekt von Language Rooms Spaß eingebaut, weil wir aus erster Hand wissen, dass es funktioniert.',
  extensiveGrammarFocus: 'Umfassender Grammatikfokus',
  vocabularyMemorization: 'Vokabeln auswendig lernen',
  limitedPracticalApplication: 'Begrenzte praktische Anwendung',
  focusOnPracticalUsage: 'Fokus auf praktischer Anwendung',
  dailyConversationPractice: 'Tägliche Gesprächsübungen',
  highConfidenceInRealSituations: 'Hohes Selbstvertrauen in realen Situationen',
  shapeTheFutureOfLanguageRooms: 'Gestalte die Zukunft von Language Rooms',
  suggestNewFeaturesAndImprovements:
    'Schlage neue Funktionen oder Verbesserungen vor',
  reportAnyIssues: 'Melde alle Probleme, die du findest',
  shareYourSuccessStories: 'Teile deine Erfolgsgeschichten',
  error: 'Fehler',
  startAConversation: 'Starte eine Konversation',
  chatWithOtherParticipants:
    'Chatte mit anderen Teilnehmern in diesem Raum. Teile Ideen, stelle Fragen oder sag einfach Hallo!',
  anonymous: 'Anonym',
  localStreamNotFound:
    'Für den Voice-Chat wird Zugriff auf dein Mikrofon benötigt. Bitte klicke auf das Mikrofon-Symbol in deinem Browser und erlaube den Zugriff, um mit anderen sprechen zu können.',
  typeMessage: 'Nachricht eingeben...',
  showChat: 'Chat anzeigen',
  hideChat: 'Chat ausblenden',
  language: 'Sprache',
  English: 'Englisch',
  Spanish: 'Spanisch',
  German: 'Deutsch',
  French: 'Französisch',
  Italian: 'Italienisch',
  Japanese: 'Japanisch',
  Chinese: 'Chinesisch',
  Korean: 'Koreanisch',
  Beginner: 'Anfänger',
  Intermediate: 'Fortgeschrittene',
  Advanced: 'Experten',
  DailyLife: 'Alltag',
  FoodAndDrink: 'Essen & Trinken',
  Travel: 'Reisen',
  Culture: 'Kultur',
  Business: 'Geschäft',
  Technology: 'Technologie',
  Entertainment: 'Unterhaltung',
  Sports: 'Sport',
  Education: 'Bildung',
  Arts: 'Kunst',
  Music: 'Musik',
  Literature: 'Literatur',
  CurrentEvents: 'Aktuelle Ereignisse',
  Science: 'Wissenschaft',
  HealthAndWellness: 'Gesundheit & Wellness',
  Hobbies: 'Hobbys',
  noRoomsFound: 'Keine Räume gefunden',
  itLooksLikeThereAreNoRooms: `Es sieht so aus, als gäbe es gerade keine Räume. Du kannst versuchen, deine Filter anzupassen oder einen neuen Raum zu erstellen, um ein Gespräch zu beginnen!`,
  participant: 'Teilnehmer',
  participants: 'Teilnehmer',
  enableVoiceChat: 'Sprach-Chat aktivieren',
  tryAgain: 'Erneut versuchen',
  loading: 'Lädt...',
  edit: 'Bearbeiten',
  stayAnonymous: 'Anonym bleiben',
  joinAnonymously: 'Anonym beitreten',
  featuredRooms: 'Beliebte Räume',
  joinOneOfOurPopularRooms:
    'Tritt einem unserer beliebten Räume bei und beginne sofort mit Muttersprachlern zu üben.',
  readyToStartSpeaking: 'Bereit zum Sprechen?',
  joinARoomAndStartPracticing:
    'Tritt jetzt einem Raum bei und übe mit Muttersprachlern. Der beste Weg zu lernen ist durch Tun!',
  findARoomNow: 'Jetzt einen Raum finden',
  foundingMember: 'Gründungsmitglied',
  pioneerBadge: 'Pionier',
  betaTester: 'Beta-Tester',
  thankYouForYourFeedback: 'Vielen Dank für dein Feedback!',
  giveFeedback: 'Feedback geben',
  sendFeedback: 'Feedback senden',
  shareFeedbackSubtitle:
    'Teile deine Gedanken, Ideen, Probleme oder sag einfach Hallo 👋🏻',
  somethingWentWrong: 'Etwas ist schief gelaufen',
  unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
  errorPageMessage:
    'Wir entschuldigen uns für die Unannehmlichkeiten. Bitte versuche es erneut oder gehe zurück zur vorherigen Seite.',
  useFeedbackTool: 'Hast du Probleme? Bitte geb uns Feedback.',
  pageNotFound: 'Seite nicht gefunden',
  pageNotFoundMessage:
    'Die Seite, die du suchst, existiert nicht oder wurde verschoben.',
  backToHome: 'Zurück zur Startseite',
  justNow: 'jetzt',
  minuteAgo: 'vor 1 Minute',
  minutesAgo: 'vor {0} Minuten',
  hourAgo: 'vor 1 Stunde',
  hoursAgo: 'vor {0} Stunden',
  dayAgo: 'vor 1 Tag',
  daysAgo: 'vor {0} Tagen',
  weekAgo: 'vor 1 Woche',
  weeksAgo: 'vor {0} Wochen',
  monthAgo: 'vor 1 Monat',
  monthsAgo: 'vor {0} Monaten',
  yearAgo: 'vor 1 Jahr',
  yearsAgo: 'vor {0} Jahren',
  letsSpeak: 'Lass uns sprechen!',
  letsSpeakMessage:
    'Denk daran, dass Fehler Teil des Lernens sind. Je mehr du sprichst, desto sicherer wirst du dich fühlen!',
  roomInfo: 'Rauminfo',
  share: 'Teilen',
  shareRoom: 'Raum teilen',
  suggestedQuestions: 'Vorgeschlagene Fragen',
  conversationStarters: 'Gesprächsstarter',
  vocabulary: 'Vokabeln',
  relatedToTags: 'Themenbezogen',
  other: 'Andere',
  questions: 'Fragen',
  general: 'Allgemeine',
  more: 'Mehr',
  needSomethingElse: 'Brauchst du etwas anderes?',
  speakingMaterialFeedbackPrompt:
    'Wenn du etwas anderes benötigst, bitte lass es uns wissen und wir werden es berücksichtigen.',
  additionalFeedback:
    'Auch wenn du zusätzliches Feedback zum Material hast, würden wir uns darüber freuen.',
  enterYourName: 'Wie lautet dein Name?',
  learnLanguages: 'Lerne Sprachen',
  through: 'Durch',
  speaking: 'Sprechen',
  whichLanguageDoYouWantToSpeak: 'Welche Sprache möchtest du sprechen?',
  joinSpeakersFromOver: 'Sprich mit Leuten aus über 20+ Ländern',
  exploreMoreLanguages: 'Mehr Sprachen erkunden',
  online: 'online',
  languagesAvailable: 'Sprachen verfügbar',
  practiceAnytime: 'Übe jederzeit',
  why: 'Warum',
  worksBetter: 'besser funktioniert',
  traditionalLearning: 'Traditionelles Lernen',
  yearsOfFrenchInSchool: 'Jahre Französisch in der Schule',
  countlessHoursMemorizingVerbConjugations:
    'Unzählige Stunden Verbkonjugationen auswendig lernen',
  perfectTestScoresButNeverSpokeInClass:
    'Perfekte Testergebnisse, aber nie im Unterricht gesprochen',
  resultCantHoldBasicConversationToday:
    'Ergebnis: Kann heute keine einfache Konversation führen',
  monthsOfSpanishPractice: 'Monate Spanisch-Übung',
  dailyConversationsWithNativeSpeakers:
    'Tägliche Gespräche mit Muttersprachlern',
  learningThroughRealWorldDiscussions: 'Lernen durch reale Diskussionen',
  resultConfidentlySpeakingWithNatives:
    'Ergebnis: Selbstbewusstes Sprechen mit Muttersprachlern',
  immediatePractice: 'Sofortige Übung',
  nativeSpeakers: 'Muttersprachler',
  realResults: 'Echte Ergebnisse',
  startSpeakingFromDayOneNoMoreSilentStudying:
    'Ab dem ersten Tag sprechen, kein stilles Lernen mehr',
  learnHowLocalsReallyTalkNotJustTextbookPhrases:
    'Lerne, wie Einheimische wirklich sprechen, nicht nur Lehrbuchphrasen',
  buildGenuineConfidenceThroughActualConversations:
    'Aufbau echter Selbstsicherheit durch tatsächliche Gespräche',
  realStoriesRealProgress: 'Echte Geschichten, Echter Fortschritt',
  joinThousandsOfLanguageLearners:
    'Schließe dich Tausenden von Sprachlernenden an, die durch Language Rooms ihre Sprechsicherheit gefunden haben',
  afterReturningFromSpainIStruggled:
    'Nach der Rückkehr aus Spanien hatte ich Schwierigkeiten, mein Spanisch zu erhalten. Language Rooms gibt mir täglich die Möglichkeit, mit Muttersprachlern zu sprechen und meine Fähigkeiten zu verbessern.',
  iCompletedAllOfDuolingo:
    'Ich habe viele Sprachlektionen abgeschlossen, konnte aber nicht selbstbewusst sprechen. Hier übe ich echte Gespräche und meine Sprechangst ist verschwunden!',
  asABusyProfessionalINeededFlexiblePracticeTimes:
    'Als beschäftigter Berufstätiger brauchte ich flexible Übungszeiten. Die 24/7-Verfügbarkeit von Muttersprachlern hier ist genau das, was ich gesucht habe.',
  returnedExchangeStudent: 'Ehemalige Austauschstudentin',
  languageEnthusiast: 'Sprachenthusiast',
  businessProfessional: 'Geschäftsfrau',
  joinLearnersFromOver: 'Schließe dich Lernenden aus über',
  whoAreAlreadyImprovingTheirLanguageSkills:
    'an, die bereits ihre Sprachkenntnisse durch echte Gespräche verbessern',
  countries: 'Ländern',
  findThePerfectRoomForYou: 'Finde den perfekten Raum für dich',
  email: 'E-Mail',
  muted: 'Mikrofon ausgeschaltet',
  unmuted: 'Mikrofon an',
  availableSlots: 'Verfügbarer Platz',
  typeAMessage: 'Nachricht eingeben...',
  you: 'Du',
  noMessagesYetStartTheConversation:
    'Noch keine Nachrichten. Starte die Konversation!',
  microphoneAccessRequired: 'Mikrofonzugriff erforderlich',
  microphoneAccessRequiredDescription:
    'Um diese Plattform zu verwenden, benötigst du den Zugriff auf dein Mikrofon. Bitte aktiviere ihn in deinen Browser-Einstellungen und aktualisiere die Seite.',
  faster: 'Schneller',
  thanTraditionalLearning: 'als traditionelles Lernen',
  realWorldSkills: 'Real-World Skills',
  naturalLanguagePatternsAndExpressions:
    'Natürliche Sprachmuster und Ausdrücke',
  buildConfidenceThroughRegularPractice:
    'Selbstsicherheit durch regelmäßige Übung',
  strongFoundation: 'Starke Grundlage',
  structuredGrammarAndVocabularyLearning:
    'Strukturierte Grammatik und Vokabeln',
  systematicProgressionThroughLanguageLevels:
    'Systematischer Fortschritt durch Sprachstufen',
  professionalGuidanceAndFeedback: 'Professionelle Anleitung und Feedback',
  realWorldSkillsDescription: 'Echte Gespräche mit Muttersprachlern',
  improve: 'Verbessere',
  yourLanguageSkills: 'Deine Sprachkenntnisse',
  combineStructuredLearningWithRealWorldSpeakingPractice:
    'Kombiniere strukturiertes Lernen mit praktischer Sprechübung',
  serverIssues: 'Server-Verbindungsprobleme',
  serverIssuesDescription:
    'Wir haben derzeit technische Schwierigkeiten mit unseren Sprachchat-Servern. Die Sprachchat-Funktionalität könnte vorübergehend eingeschränkt sein. Unser Team arbeitet an der Lösung dieses Problems. Wir entschuldigen uns für die Unannehmlichkeiten.',
  connecting: 'Verbinden',
  roomIsFull: 'Dieser Raum ist voll',
  joinAnotherRoom: 'Einen anderen Raum beitreten',
  audioSettings: 'Audio-Einstellungen',
  microphone: 'Mikrofon',
  speaker: 'Lautsprecher',
  audioDevices: 'Audio-Geräte',
  audioDevicesDescription:
    'Wähle die Audio-Geräte, die du für den Sprachchat verwenden möchtest.',
  browseOtherRooms: 'Andere Räume durchsuchen',
  roomIsFullDescription:
    'Dieser Raum ist derzeit voll. Du kannst entweder auf einen Platz warten oder einen anderen Raum auswählen.',
  readyToJoin: 'Bereit zum Beitreten{0}?',
  didntFindARoomThatFitsYou: 'Keinen Raum gefunden, der zu dir passt?',
  createYourOwnRoomAndStartAConversation:
    'Erstelle deinen eigenen Raum und beginne eine Konversation auf deinen eigenen Bedingungen.',
  createARoom: 'Einen Raum erstellen',
  metaDefaultTitle: 'Sprechen. Lernen. Connecten. Language Rooms.',
  metaDefaultDescription:
    'Kontakt zu Muttersprachlern aufnehmen, sich in echte Gespräche einklinken und durch Sprechen lernen. Bei Language Rooms steht das Sprechen an erster Stelle, damit das Sprachenlernen Spaß macht und effektiv ist. Mach mit und sprich dich in die Sprache ein!',
  metaDefaultKeywords:
    'Sprache, Sprechen, Lernen, Verbinden, Üben, Sprache lernen, Sprachlernen, Language Rooms, Flussigkeit, Stimmenchat, Stimme, Englisch, Spanisch, Deutsch',
  metaDefaultCanonical: 'https://language-rooms.com/de',
} as const;
